import { AppEnvironment } from 'app/app-config/app-config.model';

/**
 * Used to configure the SplitIO API key for each environment.
 * You can find the list of Kin's SplitIO API keys here: https://app.split.io/org/cbc88ea0-8647-11ea-bae8-0ed25467b33f/ws/cbd16840-8647-11ea-bae8-0ed25467b33f/admin/apis/sdkkeys.
 * You may notice that these are the same API keys used for ng-kin and efnol-ui; that is intentional.
 * See these SplitIO docs to learn more about how it is important to use different keys across different environments, but it is not important
 * to use different keys across different applications:
 * https://help.split.io/hc/en-us/articles/360033557092-SDK-overview#:~:text=under%20your%20control-,API%20keys,the%20appropriate%20API%20key%20type
 * https://help.split.io/hc/en-us/articles/360006854852-Frontend-and-backend-API-key-usage
 */
export const splitIOEnvConfig: ReadonlyMap<AppEnvironment, string> = new Map([
  ['local', 'ud9iosss7a1q2fv042c4625llh1dbbjoj6ca'],
  ['development', 'ud9iosss7a1q2fv042c4625llh1dbbjoj6ca'],
  ['staging', 'jg52msmphbtu6qhk9p3jj9vdm6mn6vve2dfn'],
  ['production', 'jgvvc544opgimfu37j6tvja06n1q998vbe0f'],
]);

export const FEATURE_FLAGS = {
  PASSIVE_FULLSTORY_EVENT_TRACKING: 'passive_fullstory_event_tracking',
  QT_1034_TCPA_CONSENT_EIG: 'QT-1034_TCPA_Consent_EIG', // Determines whether or not we show the EIG consent checkbox on about you
  QT_1116_auto_progress_forms: 'QT-1116_auto_progress_forms', // Determines whether or not we auto progress forms
  AR_QUOTING_START_SOCIAL_PROOF: 'ar-quoting-start_social_proof', // Determines whether or not we show the social proof on the quoting start page
  AR_QUOTING_ABOUT_YOU_SOCIAL_PROOF: 'ar-quoting-about-you_social_proof', // Determines whether or not we show the social proof on the about you page
  QT_1403_AUTOSCROLL_ACCORDION: 'QT-1403-autoscroll-accordion', // Determines whether or not we autoscroll the accordion on the Review Page
  QT_1503_CUSTOMER_GENERATED_QUOTES: 'QT-1503_customer_generated_quotes', // Determines whether or not we save quote PDFs when customers click print or save quote
  AB_242_EIG_ON_POSITION_ONE: 'AB-242_EIG_on_position_one', // Determines Test whether displaying a EIG link in the top position of the out-of-market leads page increases net revenue per out-of-market lead
  AB_332: 'AB-332', // Bundling disclosure timing experiment. Treatments: v0_control, v3_postinfo, v4_postonline
} as const;

export type FeatureFlag = keyof typeof FEATURE_FLAGS;
